import {ReportTranslationsType} from './ReportTranslationsType';

export const esReportTranslations: ReportTranslationsType = {
  'report.modal.title': 'Generación del Informe de Campaña',
  'report.modal.error.title': 'Error',
  'report.modal.error.text':
    'Se ha producido un error durante la generación del informe',
  'report.modal.selector.text':
    'La generación de un informe de campaña puede tardar varios minutos. La descarga se iniciará automáticamente una vez finalizada la operación.',
  'report.modal.error.button': 'Cerrar',
  'report.modal.button': 'Descargar',
};
